import useModal from '../useModal/useModal';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Col, Input, Row} from 'reactstrap';
import { isMobile } from 'react-device-detect';
import useFiltersWidget from './useFiltersWidget';
import { useState } from 'react';
import { toast } from 'react-toastify';

const FilterSetSaveModal = ({id, ...props}) => {
  const { modalProps, headerProps, toggle } = useModal(id, {hideClose: false, header: {color: 'black', background: 'white'}});
  const {
    buttonRightOutline,
    selectedFilters
  } = props;
  const { saveFilterSet } = useFiltersWidget();
  const [filterName, setFilterName] = useState('');

  const onRightClick = () => {
    saveFilterSet(filterName, selectedFilters);
    toggle();
    toast.success('Filter Set Saved!');
  };

  return (
    <Modal {...modalProps} modalClassName="filters-set-save-modal">
      <ModalHeader {...headerProps}>Create Filter Set</ModalHeader>
      <ModalBody className={isMobile ? 'px-2' : 'pt-0'} >
        <Row>
          <Col>
            <div style={{color: 'black', fontWeight: '500'}} className="main-header pt-2">Name your Filter Set so it appears in the dropdown in the filter area.</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input 
            placeholder='Filter Set Name' className='mt-2' onChange={(e) => {setFilterName(e.target.value)}} value={filterName} />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className='justify-content-center'>
        <Col className='pr-0'>
            <Button disabled={!filterName} onClick={onRightClick} block outline={buttonRightOutline} className='py-2' style={{float: 'right', color: 'white'}} color={'blueFilter'}>Create Filter Set</Button>
        </Col>
      </ModalFooter>
    </Modal>
  )
}

export default FilterSetSaveModal;
